<template>
  <!-- CREATION MODE -->
  <layout v-if="isCreation">
    <router-view />
  </layout>
  <!-- PLAYER MODE -->
  <container v-else>
    <router-view />
  </container>
</template>

<script>
// Components
import layout from "@/components/Layout";

// Default app font
import "@fontsource/roboto";

export default {
  components: {
    layout,
  },
  data() {
    return {
      isCreation: this.$store.state.config.system.isCreation,
    };
  },
  mounted() {
    this.initApp();
    this.restoreSettings();
  },
  methods: {
    initApp() {
      // If we are on an electron app
      if (this.isElectron()) {
        // If we are in player mode
        if (!this.isCreation) {
          this.$router.push({ path: "/player" });
        } else {
          // IF ELECTRON RUN WE ACTIVATE THE FUNCTIONNALITIES ON REDUCE / MAXIMIZE / CLOSE
          this.appFunc = require("electron").remote;
          const windows = this.appFunc.getCurrentWindow();

          // In creation mode we make sure that the window is resizable
          windows.setResizable(true);
        }
      } else {
        // In non electron app we disable player page
        this.isCreation = true;
      }
    },
    isElectron() {
      let isElectron = false;
      if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") {
        isElectron = true;
      }

      // Main process
      if (typeof process !== "undefined" && typeof process.versions === "object" && !!process.versions.electron) {
        isElectron = true;
      }

      // Detect the user agent when the "nodeIntegration" option is set to true
      if (navigator.userAgent.indexOf() !== undefined) {
        if (
          typeof navigator === "object" &&
          typeof navigator.userAgent === "string" &&
          navigator.userAgent.indexOf("Electron") >= 0
        ) {
          isElectron = true;
        }
      }

      return isElectron;
    },
    restoreSettings() {
      // Restore lang
      this.$i18n.locale = this.$store.state.config.prefs.lang;
      // Restore theme
      this.$vuetify.theme.dark = this.$store.state.config.prefs.darkTheme === "true";
    },
  },
};
</script>

<style>
@import "./assets/css/global.css";
@import "./assets/css/custom_scrollbar.css";
</style>
